import {
  getHorizontalFrozenLinePos,
  getVerticalFrozenLinePos,
} from '../../../helpers/frozenLinesHelpers';
import { SelectedLineType } from '../../../types';
import { MoveableFrozenLineProps } from './useFrozenLines';

interface FrozenLinesProps extends MoveableFrozenLineProps {
  linePosX: number;
  linePosY: number;
  selectedLine: SelectedLineType;
  sheetId: string;
  expectedIndex: number;
}
export const FrozenLinesIndicator: React.FC<FrozenLinesProps> = ({
  linePosX,
  linePosY,
  selectedLine,
  expectedIndex,
  ...props
}) => {
  if (selectedLine === 'none') return null;
  const { expectedFreezePlacement, moveableLine } = getLinePosition(
    selectedLine,
    expectedIndex,
    selectedLine === 'column' ? linePosX : linePosY,
    props
  );

  const lineView = (
    x: number,
    y: number,
    width: number,
    height: number,
    movingLine: boolean
  ) => (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
        background: movingLine ? props.selectionBorder : props.selectionFill,
        position: 'absolute',
        cursor: 'grab',
        opacity: movingLine ? 0.3 : 0.6,
        zIndex: 2,
      }}
      // key={`${sheetId}-frozen-line`}
    />
  );

  return (
    <>
      {expectedFreezePlacement &&
        lineView(
          expectedFreezePlacement.left,
          expectedFreezePlacement.top,
          expectedFreezePlacement.width,
          expectedFreezePlacement.height,
          false
        )}
      {moveableLine &&
        lineView(
          moveableLine.left,
          moveableLine.top,
          moveableLine.width,
          moveableLine.height,
          true
        )}
    </>
  );
};

const getLinePosition = (
  selectedLine: SelectedLineType,
  expectedIndex: number,
  linePos: number,
  props: MoveableFrozenLineProps
) => {
  if (selectedLine === 'row')
    return getHorizontalFrozenLinePos(linePos, expectedIndex, props);
  else if (selectedLine === 'column')
    return getVerticalFrozenLinePos(linePos, expectedIndex, props);

  return {
    expectedFreezePlacement: undefined,
    moveableLine: undefined,
  };
};

export default FrozenLinesIndicator;
